import { createFileRoute } from '@tanstack/react-router';
import { BackupsSettingsPage } from '../features/settings/BackupsSettingsPage';

export const Route = createFileRoute('/settings/backups')({
  component: BackupsSettingsPage,
});
